export const getSelectableVideoOrganizations = (organizations = []) => (
  (Array.isArray(organizations) ? organizations : [])
    .filter(organization => organization?.videoProcessingEnabled !== false)
);

export const getVideoProcessingAccess = (organization) => ({
  hasVideoProcessingWriteAccess: Boolean(organization)
    && organization.videoProcessingWriteEnabled !== false,
  isReadOnlyMode: organization?.videoProcessingWriteEnabled === false,
});
